import { SearchResult, SearchType } from '@/app/(main)/_components/search-modal/search-modal.types';

export const mostSearchedProceduresElasticTest: SearchResult[] = [
  {
    id: '734e0857-61ac-4d49-91b2-faba67f27993',
    searchType: SearchType.PRESENTIAL_CONSULTATION,
    displayName: 'Consulta com Oftalmologista',
    subText: 'Consulta presencial - 10.10.10.12 - 225265',
    code: '10101012 - 225265',
    slug: 'consulta-em-consultorio-oftalmologia',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: 'df67d3c1-2d16-4f2e-9374-4b1e6750d0d4',
    searchType: SearchType.PRESENTIAL_CONSULTATION,
    displayName: 'Consulta com Clínico Geral',
    subText: 'Consulta presencial - 10.10.10.12 - 225125',
    code: '10101012 - 225125',
    slug: 'consulta-em-consultorio-clinico-geral-ou-clinica-medica',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: '53941341-03f7-43f0-a8d3-1b82f66380ab',
    searchType: SearchType.ONLINE_CONSULTATION,
    displayName: 'Teleconsulta com Clínico Geral',
    subText: 'Teleconsulta - 14.57.28.33',
    code: '14572833',
    slug: 'consulta-em-consultorio-clinico-geral-ou-clinica-medica-online',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: '830d1c0f-d12e-4c5b-9911-a7e3258b43f1',
    searchType: SearchType.LABORATORIAL_EXAM,
    displayName: 'Hemograma Completo (com Contagem de Plaquetas)',
    subText: 'Exame Laboratorial - 40.30.43.61',
    code: '40304361',
    slug: 'hemograma-meu-amigo-se-algum-procedimento-tiver-um-nome-maior-que-o-desse-hemograma-ai-lascou-porque-agora-vamos-limitar-para-256-o-nome-desse-procedimento-ta-gigante-assim-apenas-para-testar-espero-que-entendam-hahaha-hihihi-eh-melhor-se-segurarem-porque-a-jiripoca-vai-piar-hemograma-meu-amigo-se-algum-procedimento-tiver-um-nome-maior-que-o-desse-hemograma-ai-lascou-porque-agora-vamos-limitar-para-256-o-nome-desse-procedimento-ta-gigante-assim-apenas-para-testar-espero-que-entendam-hahaha-hihihi-eh-melhor-se-segurarem-porque-a-jiripoca-vai-piar',
    source: 'ELASTIC_SEARCH',
  },
  {
    id: '435663dd-5636-4da7-98cb-ffa4d85a910d',
    searchType: SearchType.PRESENTIAL_CONSULTATION,
    displayName: 'Consulta com Psiquiatra',
    subText: 'Consulta presencial - 10.00.06.49',
    code: '10000649',
    slug: 'consulta-em-psicologia',
    source: 'ELASTIC_SEARCH',
  },
];
